import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { CharacteristicObject } from 'src/app/models/characteristics/characteristic/characteristic-object.model';
import { isNullOrUndefined } from 'util';
import { CharacteristicsObject } from 'src/app/models/characteristics/characteristics.model';
import { MultiCharacteristicObject } from 'src/app/models/characteristics/characteristic/multi-characteristic-object.model';

@Component({
  selector: 'app-characteristics-panel',
  templateUrl: './characteristics-panel.component.html',
  styleUrls: ['./characteristics-panel.component.css']
})
export class CharacteristicsPanelComponent implements OnInit, OnChanges {


  @Input() characteristics: Array<CharacteristicObject>;
  @Input() editable: boolean;
  @Output() diffCharacteristicsEvent = new EventEmitter();

  diffCharacteristics: Array<CharacteristicObject>;
  clonedCharacteristics: Array<any>;

  constructor() {
  }

  ngOnInit() {
    this.diffCharacteristics = new Array<CharacteristicObject>();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!isNullOrUndefined(changes.characteristics)) {
      this.clonedCharacteristics = this.clone(changes.characteristics.currentValue);
    }
  }

  clone(items: Array<CharacteristicObject>): Array<CharacteristicObject> {
    let cloned = new Array<CharacteristicObject>();
    for (let item of items) {
      cloned.push(item.clone());
    }
    return cloned;
  }

  onCharacteristicChange($event) {
    return this.diffCharacteristicsEvent.emit(this.calculateDiff($event));
  }

  calculateDiff(newCharacteristic: CharacteristicObject): Array<any> {
    for (let j = 0; j < this.clonedCharacteristics.length; j++) {
      if (newCharacteristic.id === this.clonedCharacteristics[j].id &&
        !newCharacteristic.equals(this.clonedCharacteristics[j])) {
        this.diffCharacteristics.push(newCharacteristic);
      }
    }
    return this.diffCharacteristics;
  }

  hasMultiValue(characteristic: CharacteristicsObject) {
    if (characteristic instanceof MultiCharacteristicObject) {
      return true;
    } else {
      return false;
    }
  }

}
